import { CartLocalStorageRepository } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/CartRepository/CartLocalStorageRepository';
import { CartRepository } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/CartRepository/CartRepository';

export class CartRepositoryFactory {
  public static getRepository(): CartRepository {
    return new CartLocalStorageRepository();
  }
}
